
export { encode, decode }

function toBase62(n) {
    if (n === 0) {
        return '0';
    }
    var digits = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = '';
    while (n > 0) {
        result = digits[n % digits.length] + result;
        n = parseInt(n / digits.length, 10);
    }

    return result;
}

function fromBase62(s) {
    var digits = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = 0;
    for (var i = 0; i < s.length; i++) {
        var p = digits.indexOf(s[i]);
        if (p < 0) {
            return NaN;
        }
        result += p * Math.pow(digits.length, s.length - i - 1);
    }
    return result;
}

function encode(ints) {
    var prev = 0;
    const enc = [...ints].sort((a, b) => a - b).map(i => {
        const ii = i - prev;
        prev = i;
        return ii;
    }).map(toBase62);
    //return enc.join('.');
    
    const maxL = Math.max(...enc.map(a => a.length));
    // todo throw range error if toBase62(maxL) > 1 char
    var encoded =  toBase62(maxL)+'';
    enc.forEach(enc => {
        if  (enc.length < maxL) {
            encoded = encoded + enc + '.';
        } else {
            encoded = encoded + enc;
        }
    });
    // remove any trailing "."
    return encoded.replace(/\.$/, '');
    // return maxL + '.' + enc.map(a => a.padStart(maxL, '.')).join('')
    // https://modernartsmidtownfrontend-local.dev.dynamic.ms/favorites?fav=cz.1.Gb.vc.6O.5J.9.3x.18.2b.1b.4.a.2S.P.1n.3O.1.1.4w.2.1.d.a
    // https://modernartsmidtownfrontend-local.dev.dynamic.ms/favorites?fav=779,780,3395,5329,5751,6106,6115,6334,6404,6539,6612,6616,6626,6804,6855,6940,7176,7177,7178,7458,7460,7461,7474,7484
    // https://modernartsmidtownfrontend-local.dev.dynamic.ms/favorites?fav=2cz1.Gbvc6O5J9.3x182b1b4.a.2SP.1n3O1.1.4w2.1.d.a
}

function decode(str) {
    const maxL = fromBase62(str[0]);
    var left = str.slice(1);
    var working = '';
    var workingParts = [];
    var prev = 0;
    var pp = 0;
    var curNum;
    const decodedValues = [];

    while (left.length > 0) {
        working = left.slice(0, maxL);
        left = left.slice(maxL);
        workingParts = working.split('.')
        if (workingParts.length > 1) {
            // 
            left = workingParts.slice(1).join('.') + left;
        }
        curNum = workingParts[0];

        pp = fromBase62(curNum) + prev;
        //console.log({curNum, left, pp, prev})
        prev = pp;
        decodedValues.push(pp);
    }
    return decodedValues;

    // var prev = 0;
    // return str.split('.').map(p => {
    //     const pp = fromBase62(p) + prev;
    //     prev = pp;
    //     return pp;
    // });
}

// const tests = [
//     [2, 4, 20, 200, 1000, 1002, 1004],
//     [2, 4, 20, 200, 1000, 1002, 1004, 5000, 5020, 6000, 6040, 8000],
//     [1004, 5000, 5020, 6000, 6040, 6080, 6100, 8000],
//     [500000, 500010, 500015, 500016, 500017, 500018, 500019, 500510, 510010],
//     [810010, 9500000, 9500010, 9500015, 9500016, 9500017, 9500018, 9500019, 9500510]
// ];
// tests.forEach(t => {
//     const e = encode(t)
//     const d = decode(e);
//     console.log('encoded:', e, e.length)
//     console.log('test   :', t.join('.'), t.join('.').length)
//     console.log('decoded:', d, d.length)
//     console.log('success?', d.join('.') === t.join('.'), 1 - (e.length / t.join('.').length))
// })
